module.exports = __webpack_public_path__ + "img/frame-level.0f8fbe79.svg";